import Service, { getCallApiFunction } from '../service'
// import denormalizer from './denormalizer'
// import normalizer from './normalizer'

type DataType = {
  roomId: string
  likes: number
}

class SetLikesApi extends Service {
  constructor(data: DataType) {
    super()
    this.name = 'SET_LIKES'

    this.config = {
      url: `/v1/room/incr-likes`,
      method: 'POST',
      data,
    }
  }
}

export const setLikes = (data: DataType) => getCallApiFunction(new SetLikesApi(data))
